import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-template',
    templateUrl: './delete-template.component.html',
    styleUrls: ['./delete-template.component.scss'],
    standalone: false
})
export class DeleteTemplateComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DeleteTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  )  { }

  ngOnInit(): void {
    console.log(this.data);
  }
  closePopup(){
    this.dialogRef.close();
  }
  confirmDelete(): void {
    this.dialogRef.close('delete'); 
  }
}
